import React, {useEffect, useState} from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { MainContext } from './context/MainContext'
import AppStack from './containers/Layout/AppStack'
import {TimerProvider} from "./context/TimerContext";
import {WebSocketProvider} from "./context/SocketContext";
import { Provider } from 'react-redux';
import {store} from "./redux/store";

const App: React.FC = () => (
    <>
        <Provider store={store}>
            <MainContext>
                <TimerProvider>
                    <WebSocketProvider>
                        <Router>
                            <AppStack/>
                        </Router>
                    </WebSocketProvider>
                </TimerProvider>
            </MainContext>
        </Provider>
    </>
)

export default App